import { useMemo } from 'react';
import { usePatientVirtualAppointments } from '../../../hooks/useVirtualAppointments';
import { partitionOpenVirtualAppointments } from '../../virtual-appointments/openVirtualAppointments';
import { CountTabLabel } from './CountTabLabel';

interface VirtualAppointmentsTabLabelProps {
    patientId: string;
}

// Shares the VAs panel's query but not its hook, which would also re-resolve description images.
export function VirtualAppointmentsTabLabel({ patientId }: VirtualAppointmentsTabLabelProps) {
    const { data, status } = usePatientVirtualAppointments(patientId);
    const total = useMemo(() => {
        if (status !== 'success') return null;
        const { open, planned, history } = partitionOpenVirtualAppointments(data);
        return open.length + planned.length + history.length;
    }, [data, status]);
    return <CountTabLabel label="VAs" count={total} showZero />;
}
